import { define } from "remount";
import { EmployeeCarousel } from "../src/EmployeeCarousel/EmployeeCarousel";

define({ "employee-carousel": EmployeeCarousel });
